module.exports = __webpack_public_path__ + "static/warlock_pact_weapon-a6642eb0cef23edfdfa029fb16b0103a.jpg";